import { settings, useSetting } from '../../../settings';
import { TimeTrackingRestrictionType } from '../../../settings/settings';

type Return = {
  type: TimeTrackingRestrictionType;
  backdatedLimit?: number;
};

export const useTimeTrackingRestriction = (): Return => {
  const { value: type } = useSetting(
    settings.timeTrackingCreateOrEditRestriction()
  );

  const { value: backdatedLimit } = useSetting(
    settings.numberOfDaysAllowedForBackdatedTimeTrackingCreationOrEdit()
  );

  if (type === TimeTrackingRestrictionType.BACKDATED_LIMIT) {
    return {
      type,
      backdatedLimit,
    };
  }

  return { type };
};
